// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__38iPD","large":"styles_large__1ujQN"};